/* @flow */

import React from 'react';
import { dropdown } from 'components/UIKit/decorators';
import Row from 'components/UIKit/Flex/Row';
import Column from 'components/UIKit/Flex/Column';
import { setMessage } from 'ducks/message';
// $FlowIgnore
import { connect } from 'react-redux';
import { isIE11 } from 'constants/browserSupport';

export type DownloadDropdownType = {
  dispatch: () => {},
  setIsSpinning: () => {},
  download: () => {},
  formats: Array<String>,
  mouseUpHandler: () => {},
  mouseDownHandler: () => {},
  toggleActive: () => {},
  setActive: () => {},
  marginOffset: any,
  active: boolean,
  children: any,
  style: any,
  disabled: boolean,
}

function DownloadDropdown({
  setIsSpinning = () => null,
  dispatch,
  download,
  formats,
  mouseUpHandler,
  mouseDownHandler,
  toggleActive,
  setActive,
  active,
  marginOffset,
  children,
  style,
  disabled,
}: DownloadDropdownType): React.Element {
  return (
    <Row
      style={{
        position: 'relative',
        ...(style || {}),
      }}
      >
      <span
        onClick={() => disabled || toggleActive()}
        style={{
          display: 'flex',
        }}
        >
        { children }
      </span>

      { active
      && (
        <Column
          data-testid="dropdown-menu-options"
          className="mdl-shadow--2dp no-print"
          onMouseDown={mouseDownHandler}
          onMouseUp={mouseUpHandler}
          style={{
            width: '100%',
            position: 'absolute',
            background: 'white',
            fontSize: '1rem',
            zIndex: 1000,
            ...(marginOffset || {}),
            bottom: 0,
            left: 8,
            transform: 'translateY(100%)',
          }}
          >
          { formats.map(format => (
            <Row
              key={format}
              className="dropdown-item"
              style={{ paddingLeft: '0.5rem', textTransform: 'uppercase', lineHeight: '2.5rem' }}
              onClick={
              async () => {
                setIsSpinning(true);
                setActive(false);
                try {
                  await download(format);
                } catch (err) {
                  dispatch(setMessage('Error downloading'));
                }
                setIsSpinning(false);
              }
            }
              >
              { format }
            </Row>
          ))}
        </Column>
      )}
    </Row>
  );
}

export default connect()(dropdown(DownloadDropdown));
